export default "__VITE_ASSET__146a06ff__"